import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.addEventListener("turbo:frame-load", () => {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
                })
            }, 50)
        })
    }
}